<div class="group relative">
    <nav tabindex="0" [class]="class">
        <ul class="py-1">
            <li *ngFor="let data of dropdownItems">
                <a  class="block px-4 py-2 hover:bg-gray-100 cursor-pointer" 
                (click)="dropdownItemsEvents(data)">
                    {{data}}
                </a>
            </li>
        </ul>
    </nav>
</div>